export default __webpack_public_path__ + "static/media/115_sharkoak.6e065307.png";